import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Carousel } from 'react-bootstrap'
import ComparePlan from '../../components/subscription/updatePlan/ComparePlan'
import { GET_ALL_PACKAGE_AND_FEATURES_LIST } from '../../graphql/query'
import { useQuery } from '@apollo/client'
import LoadingSpinner from '../../components/LoadingSpinner'
import { toAbsoluteUrl } from '../../helpers'
import InitialSubscriptionCard from './InitialSubscriptionCard'

const Index = () => {
  const [selectedCurrency, setSelectedCurrency] = useState('RS')
  const [plans, setPlans] = useState<any[]>([])

  const { error, loading, data } = useQuery(GET_ALL_PACKAGE_AND_FEATURES_LIST, {
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  useEffect(() => {
    if (data) {
      const fetchedPlans = data.getAllPackageAndFeturesList.data
        .filter((item: any) => item.package.packageCategory === 'PREDEFINED') // Filter only 'PREDEFINED' plans
        .map((item: any) => {
          const {
            featuresId,
            createdBy,
            createdAt,
            updatedBy,
            updatedAt,
            askingPrice,
            ...filteredFeatures
          } = item.feature
          return {
            title: item.package.packageName.replace('_', ' '),
            price: item.package.packageAmount,
            features: filteredFeatures,
            package: item.package,
            packageFeatureId: item.package.PackageFeature[0].packageFeatureId
          }
        })
      setPlans(fetchedPlans)
    }
  }, [data])

  if (error) {
    console.log(error)
    return <p>Error loading plans.</p>
  }

  if (loading) {
    return <LoadingSpinner />
  }

  const renderCarouselItems = () => {
    const items = []
    for (let i = 0; i < plans.length; i += 3) {
      items.push(
        <Carousel.Item key={i}>
          <Row className=' text-center justify-content-end'>
            {plans.slice(i, i + 3).map((plan, index) => (
              <Col key={index} lg={4} className='mb-5  '>
                <InitialSubscriptionCard plan={plan} selectedCurrency={selectedCurrency} />
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      )
    }
    return items
  }

  // Custom styles for icons
  const iconWrapperStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '50%',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
  const iconStyle = {
    filter: 'brightness(2)',
    width: '20px',
    height: '20px'
  }

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`
      }}
    >
      <section style={{ marginTop: '40px' }}>
        <Container className='py-5'>
          <header className='text-center mb-5'>
            <Row>
              <Col lg={8} className='mx-auto'>
                <h1>Discover Our Dynamic Chatbot Pricing Plans</h1>
                <p>
                  Explore our range of subscription options for a cutting-edge chatbot experience.
                </p>
              </Col>
            </Row>
          </header>

          <Carousel
            controls
            indicators={false}
            interval={null}
            prevIcon={
              <div style={iconWrapperStyle}>
                <span className='carousel-control-prev-icon' style={iconStyle} />
              </div>
            }
            nextIcon={
              <div style={iconWrapperStyle}>
                <span className='carousel-control-next-icon' style={iconStyle} />
              </div>
            }
            prevLabel=''
            nextLabel=''
          >
            {renderCarouselItems()}
          </Carousel>

          <Row>
            <div className='row gy-4 g-xl-12'>
              <ComparePlan plans={plans} />
            </div>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default Index
